import 'react-app-polyfill/stable'

import React from 'react'
import { Amplify } from 'aws-amplify'
import { createRoot } from 'react-dom/client'

import 'chart.js/auto'

import App from './App'
import { ThemeProvider } from './contexts/ThemeContext'

import { LicenseInfo } from '@mui/x-license'

// This is the license key for the @mui/x-license package (grid and datepicker components).
LicenseInfo.setLicenseKey(
    '58dc516e8edffc0679bc140f4892866eTz0xMzIyNjcsRT0xODE5MDY1NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1zaW5nbGUsS1Y9Mg==',
)

Amplify.configure({
    API: {
        Events: {
            endpoint: import.meta.env.VITE_APP_SYNC_ENDPOINT,
            region: import.meta.env.VITE_APP_SYNC_REGION,
            defaultAuthMode: 'userPool',
        },
    },
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
            userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        },
    },
})

const container = document.getElementById('root')

if (!container) {
    throw Error('Failed to find react container element')
}

const root = createRoot(container)

root.render(
    <ThemeProvider>
        <App />
    </ThemeProvider>,
)
